import { render, staticRenderFns } from "./NormalSearchNav476.vue?vue&type=template&id=2a804920&scoped=true&"
import script from "./NormalSearchNav476.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav476.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a804920",
  null
  
)

export default component.exports